module.exports = __webpack_public_path__ + "static/img/heart-2658206_960_720.b11f7102.png";